// src/routes/ProtectedRoute.js
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = () => {
  const auth = localStorage.getItem("currentUser");

  return auth ? <Outlet /> : <Navigate to="/sign-in" />; 
};

export default ProtectedRoute;
